export default {
  actions: {
    add: 'Ajouter',
    addComment: 'Ajouter une analyse CODE',
    addThreadComment: 'Ajouter votre commentaire',
    addReply: 'Ajouter une réponse',
    back: 'Retour',
    cancel: 'Annuler',
    comment: 'Commenter',
    delete: 'Supprimer',
    capture: 'Capturer',
    close: 'Fermer',
    confirm: 'Confirmer',
    disconnect: 'Déconnecter',
    connect: 'Se connecter',
    emitReport: 'Émettre le rapport',
    notifications: 'Notifications',
    qualify: 'À nuencer',
    reject: 'À rejeter',
    reply: 'Répondre',
    remember: 'À retenir',
    save: 'Sauvegarder',
    share: 'Partager',
    search: 'Rechercher',
    create: 'Créer',
    validate: 'À valider',
    shareWithPeopleOrGroup: 'Partager avec des personnes, des groupes formels ou des groupes de réflexion',
    addPeopleOrGroup: 'Ajouter avec des personnes, des groupes formels ou des groupes de réflexion.',
    noResult: 'Aucun résultat',
    linkToReflection: "Ajouter à la bibliographie d'une réflexion",
  },
  errors: {
    generic: 'Une erreur est survenue, veuillez réessayer.',
    errorOccuredContactUsIfPersists: 'Une erreur est survenue, contactez-nous si le problème persiste',
  },
  documentUpload: {
    action: 'Téléverser un document',
    title: 'Téléversement de document',
    uploadAndNext: "Téléverser et passer à l'analyse",
    redirecting: "Redirection vers l'analyse dans NOOS...",
    errors: {
      creation: `Une erreur est survenue lors de la création de l'analyse associée au
      document téléversé. Veuillez essayer à nouveau et contacter le support
      si le problème persiste.`,
      noEmpty: 'Ce champs ne peut être vide',
    },
  },
  permissions: {
    Owner: 'Propriétaire',
  },
  dialogs: {
    quit: {
      header: 'Avertissement',
      description: 'Voulez-vous vraiment quitter?\n(Attention! Toutes les modifications non sauvegardées seront perdues.)', // eslint-disable-line
    },
  },
  captureDocument: {
    checkbox: {
      downloadAuthorized: 'Télécharger le contenu',
    },
    textField: {
      addDocumentTitle: 'Ajouter un titre au document',
      addDocumentDescription: 'Ajouter une description au document',
    },
    legal: 'NOOS est un outil d’analyse et de sensemaking qui peut être utilisé en ligne à partir d’un site original. L’usager est tenu de respecter les droits d’auteurs lors de l’utilisation de l’outil : veuillez vous assurer qu’un contenu est libre de droits et peut être rediffusé ou que vous détenez les droits requis avant tout téléchargement de contenu protégé.', // eslint-disable-line
    analysisCreated: "Création de l'analyse réussie",
    analysisCreationFailed: 'Erreur lors la création, communiquez avec nous si le problème persiste.',
  },
  evaluationForm: {
    actions: {
      addSelectedText: 'Ajouter le texte sélectionné',
    },
    headers: {
      evaluation: 'Évaluation',
      generalValue: 'Valeur général',
      significantElements: 'Élément significatif',
    },
    toggles: {
      detailed: {
        on: "Masquer l'évaluation détaillée",
        off: 'Faire une évaluation détaillée',
      },
    },
    tooltips: {
      addSelectedText: 'Pour ajouter un élement significatif,\n sélectionnez une portion de texte sur la\n page web et cliquez sur le bouton "Ajouter\n le texte sélectionné". Choisissez ensuite\n comment le classifier avec les options "!", "?", "-"', // eslint-disable-line
      qualify: 'Permet d\'identifier un élément de contenu qui vous semble pertinent mais qui doit faire l\'objet d\'une validation plus avancée, être complété ou être nuancé.', // eslint-disable-line
      remember: 'Permet d\'identifier un élément de contenu jugé particulièrement pertinent à considérer dans les réflexions et décisions.', // eslint-disable-line
      validate: 'Permet d\'identifier un élément de contenu qui vous semble contestable voire potentiellement non fondé. Ces types d\'éléments contribuent à mieux comprendre le contexte général. Ils seront évités comme fondement de prise de décision s\'ils ne peuvent être validés ou, à titre d\'exemple, ils serviront à mieux cerner l\'argumentaire requis pour répondre à une perception potentiellement erronée.', // eslint-disable-line
      evaluation: 'Permet d\'évaluer la valeur d\'un document selon son apport potentiel pour faire avancer les réflexions en lien avec les objectifs priorisés.  Votre évaluation indiquera à Noos s\'il doit s\'inspirer de cette information pour vous alimenter en prochaine information.', // eslint-disable-line
      generalValue: 'L\'information est pertinente pour soutenir et faire progresser les réflexions en lien avec les objectifs.', // eslint-disable-line
      significantElements: 'Permet de mettre en relief un segment de texte dont le contenu a une importance particulière.',
    },
  },
  footer: {
    p: {
      0: 'Extension Noos version {{version}}',
      1: '© Noos Technologie {{year}}',
      2: 'Tous droits réservés',
    },
  },
  globals: {
    similarDocuments: 'Documents similaires',
    loading: 'Chargement',
    category: {
      plural: 'Catégories',
      single: 'Catégorie',
    },
    description: 'Description',
    group: {
      plural: 'Groupes',
      single: 'Groupe',
    },
    email: 'Courriel',
    password: 'Mot de passe',
    report: {
      plural: 'Rapports',
      single: 'Rapport',
      withCount: '{count} rapports',
    },
    reply: {
      plural: 'Réponses',
      single: 'Réponse',
      withCount: '{count} réponses',
    },
    title: 'Titre',
    unclassified: 'Non classé',
    user: {
      plural: 'Uitilisateurs',
      single: 'Uitilisateur',
      withCount: '{count} Uitilisateurs',
    },
    reflection: {
      single: 'Réflexion',
      plural: 'Réflexions',
    },
    search: 'Recherche',
  },
  mainSections: {
    portfolio: {
      short: 'Portfolio',
      long: 'Portfolio',
    },
    journal: {
      short: 'Journal',
      long: 'Journal',
    },
    reflection: {
      short: 'Réflexions',
      long: 'Réflexions',
    },
  },
  list: {
    categories: {
      additionalInfos: 'Information additionnel',
      general: 'Objectif général',
      objectives: 'Objectifs',
      strategies: 'Stratégies',
      tactics: 'Tactiques',
    },
    emission: {
      reports: {
        emitted: 'Rapport émis le {date}',
        current: 'Rapport actuel',
      },
    },
    retention: {
      document: {
        actions: {
          considered: 'Considérer le document',
          notRetained: 'Ne pas retenir ce document',
          retained: 'Retenir ce document',
        },
        selected: {
          considered: 'Considéré',
          notRetained: 'Non retenu',
          retained: 'Retenu',
        },
      },
    },
  },
  ratings: {
    names: {
      criticalUrgency: 'Critique',
      feasibility: 'Faisabilité',
      learningProcessImprovement: 'Apprentissage',
      mobilisation: 'Mobilisation',
      noveltyComplementarity: 'Nouveauté',
      operationalization: 'Opérationnalisation',
      relevanceUsefulness: 'Cohérence stratégique',
      resolution: 'Résolution',
      validityCredibility: 'Validité',
    },
    tooltips: {
      criticalUrgency: 'L\'information nécessite une réflexion rapide ou une action urgente en raison de son impact majeur potentiel sur les objectifs', // eslint-disable-line
      feasibility: 'L\'information propose des pistes de solutions pouvant être réalistement mises en œuvre au sein de notre organisation', // eslint-disable-line
      learningProcessImprovement: 'L\'information propose des leçons issues d\'expériences réelles permettant de revalider, optimiser ou recalibrer les orientations, stratégies ou moyens en cours ', // eslint-disable-line
      mobilisation: 'L\'information propose des stratégies, moyens, outils, ressources pouvant soutenir la mobilisation des parties prenantes envers les objectifs', // eslint-disable-line
      noveltyComplementarity: 'L\'information apporte de nouvelles perspectives ou idées pour mieux comprendre le contexte ou pour explorer différemment comment atteindre les objectifs', // eslint-disable-line
      operationalization: 'L\'information fournit des stratégies, moyens, outils, ressources pouvant être utilisés ou implantés immédiatement pour soutenir l\'avancement vers les objectifs', // eslint-disable-line
      relevanceUsefulness: 'L\'information est en lien étroit avec les objectifs visés et est susceptible d\'impacter les décisions et orientations', // eslint-disable-line
      resolution: 'L\'information offre des pistes de solution concrètes permettant de résoudre partiellement ou complètement une problématique empêchant d\'avancer efficacement sur les objectifs', // eslint-disable-line
      validityCredibility: "L'information est issue d'une source crédible et peut être vérifiée",
    },
  },
  reflectionForm: {
    analysisCard: {
      insertDoc: {
        quote: 'Insérer en citation',
        support: 'Insérer en appui',
      },
    },
    headers: {
      reflection: 'Réflexion',
      readOnly: 'Lecture Seule',
    },
    tooltips: {
      c: 'Clarification (C) : Expliquez pourquoi cette information vous apparaît utile pour mieux avancer vers les objectifs ou en quoi elle pourrait impacter les décisions ou orientations actuelles (les remettre en question ou les consolider).', // eslint-disable-line
      o: 'Option (O):  Partagez les idées nouvelles que vous avez détectées dans le document ou qui vous sont inspirées par cette information, et qui pourraient potentiellement aider à rencontrer les objectifs visés.', // eslint-disable-line
      d: 'Développement (D):   Identifiez des idées, stratégies et moyens permettant de développer ou renforcer une solution potentielle ou en cours afin d\'en réduire le risque ou d\'en faciliter une implantation à succès', // eslint-disable-line
      e: 'Expérimentation (E):  Identifiez ou partagez des outils, résultats et leçons apprises facilitant et accélérant la planification, la mesure, les suivis et l\'adaptation d\'actions en cours ou futures.', // eslint-disable-line
      reflection: 'Permet de contribuer par votre analyse personnelle à identifier comment utiliser l\'information pour soutenir les prochaines avancées de réflexions ou les actions.', // eslint-disable-line
    },
    reloadPanel: {
      message: {
        newSchema: "Une nouvelle version du schéma de l'éditeur est disponible, veuillez recharger l'application svp...", // eslint-disable-line
        connectionError: 'Impossible de rejoindre le serveur de collaboration. Si le problème persiste, veuillez contacter le support.', // eslint-disable-line
        accessDenied: 'Vous n\'avez pas les droits requis pour acceder ce document.',
        unknown: 'Une erreur inconnue est survenue. Si le probleme persiste, merci de contacter le support.',
      },
      buttonCaption: 'Recharger',
    },
  },
  shareForm: {
    headers: {
      share: 'Partage',
    },
    textField: {
      sharingMessageField: 'Ajouter un message pour le partage',
    },
  },
  validation: {
    alpha: 'Le champ {_field_} ne peut contenir que des lettres',
    alpha_num: 'Le champ {_field_} ne peut contenir que des caractères alpha-numériques',
    alpha_dash: 'Le champ {_field_} ne peut contenir que des caractères alpha-numériques, tirets ou soulignés',
    alpha_spaces: 'Le champ {_field_} ne peut contenir que des lettres ou des espaces',
    between: 'Le champ {_field_} doit être compris entre {min} et {max}',
    confirmed: 'Le champ {_field_} ne correspond pas',
    digits: 'Le champ {_field_} doit être un nombre entier de {length} chiffres',
    dimensions: 'Le champ {_field_} doit avoir une taille de {width} pixels par {height} pixels',
    email: 'Le champ {_field_} doit être une adresse e-mail valide',
    excluded: 'Le champ {_field_} doit être une valeur valide',
    ext: 'Le champ {_field_} doit être un fichier valide',
    image: 'Le champ {_field_} doit être une image',
    integer: 'Le champ {_field_} doit être un entier',
    length: 'Le champ {_field_} doit contenir {length} caractères',
    max_value: 'Le champ {_field_} doit avoir une valeur de {max} ou moins',
    max: 'Le champ {_field_} ne peut pas contenir plus de {length} caractères',
    mimes: 'Le champ {_field_} doit avoir un type MIME valide',
    min_value: 'Le champ {_field_} doit avoir une valeur de {min} ou plus',
    min: 'Le champ {_field_} doit contenir au minimum {length} caractères',
    numeric: 'Le champ {_field_} ne peut contenir que des chiffres',
    oneOf: 'Le champ {_field_} doit être une valeur valide',
    regex: 'Le champ {_field_} est invalide',
    required: 'Le champ {_field_} est obligatoire',
    required_if: 'Le champ {_field_} est obligatoire lorsque {target} possède cette valeur',
    size: 'Le champ {_field_} doit avoir un poids inférieur à {size}KB',
    double: 'Le champ {_field_} doit être une décimale valide',
  },
  views: {
    accesses: 'Accès',
    notifications: {
      analysisModified: {
        body: 'a modifié',
      },
      analysisShared: {
        body: 'a partagé',
      },
      missionAssigned: {
        body: 'vous a assigné la mission',
      },
      missionAccomplished: {
        body: 'a accompli sa mission',
      },
    },
    analysis: {
      commentBy: 'Commenté par',
      highlightBy: 'Surligné par',
      foundBy: 'Trouvé par',
      ficheInfoLinkName: 'document',
    },
  },
  mission: {
    fulfill: 'Accomplir ma mission',
    errorMissingAssignee: 'Vous devez assigner des collègues à votre mission.',
    errorMissingMission: 'Vous devez définir une mission.',
    visibilityWarning: 'Les missions sont visibles par tous les participants de ce fil d\'analyse.',
  },
  analysis: {
    tags: 'Étiquettes',
    reflexions: 'Réflections',
    noReflexion: 'Aucune réflexion',
    participants: 'Participants',
    likedReflexions: "Réflexions liées à l'analyse ({count})",
  },
  components: {
    ExpressAnalysis: {
      success: 'Sauvegarde réussie',
    },
    CreateDocumentFromUpload: {
      error: "Erreur lors de la création de l'analyse suite au téléversement",
    },
    fileUploader: {
      uploading: 'Téléversement: ',
    },
    pdfViewer: {
      showAllPages: 'Voir toutes les pages',
      loading: 'Chargement du document...',
    },
  },
  extension: {
    summary: {
      title: 'Analyse collaborative',
      threads: 'Aucun autre fil | 1 autre fil | {count} autres fils',
      participants: 'Membres du fil',
      tags: 'Étiquettes',
      evaluationTitle: 'Pertinence',
      topElementsTitle: 'Top analyses',
      evaluation: 'Aucune évaluation | 1 évaluation | {count} évaluations',
      emptySummaryText: 'Soyez le premier à anlyser ce document',
      goToTopElement: "Aller à l'élément en vedette",
      commented: 'Commentaire émis',
      highlightedElement: 'Élément surligné',
      addedElement: 'Élément ajouté',
    },
    userAnalyses: {
      allAnalyses: 'Toutes les analyses',
      myAnalysis: 'Mon analyse',
      evaluation: 'Pertinence',
      modified: 'Modifié',
      created: 'Créé',
      accomplishedMissions: 'ont rempli la mission',
      newThread: 'Créer un fil d\'analyse',
      description: 'Débutez votre analyse dans cette section',
      events: {
        modified: 'Modifié',
        created: 'Créé',
        highlighted: 'Surligné',
        added: 'Ajouté',
        commented: 'Commenté',
      },
      highlights: {
        title: 'Élément significatif',
        tooltip: "Sélectionnez l'information significative.",
      },
      comments: {
        title: 'Analyses CODE',
        tooltip: 'Ajoutez votre analyse. Sélectionnez la lettre CODE correspondante pour expliquer sa contribution spécifique.',
        reply: {
          placeholder: 'Partagez votre réflexion...',
        },
        showMore: 'Afficher 1 autre analyse CODE | Afficher {nbComments} autres analyses CODE',
        hide: 'Cacher 1 analyse CODE | Cacher {nbComments} analyses CODE',
      },
      missions: {
        title: "Missions d'analyse : Qu'en pensez vous?",
        tooltip: "Ajoutez un message ou créer une mission d'analyse.",
      },
    },
    footer: {
      seeMyAnalysis: 'Voir mon analyse',
      addMyAnalysis: 'Ajouter mon analyse à ce fil',
      sendButton: {
        linkReflection: {
          aclConfirmationDialog: {
            title: 'Autoriser les nouveaux participants',
            descriptionUser: "Les utilisateurs ci-dessous n'ont pas les accès requis au fil d'analyse choisi:",
            descriptionGroup: "Les groupes ci-dessous n'ont pas les accès requis au fil d'analyse choisi:",
            confirmButtonLabel: 'Donner accès et créer',
            cancelButtonLabel: 'Annuler',
          },
        },
      },
    },
    analysisSelector: {
      contributionsSingular: 'contribution',
      contributionsPlural: 'contributions',
    },
  },
};
